module.exports = __webpack_public_path__ + "static/scheduleHand-70ea6db6a621616d2f9310aa21f615d6.png";